import React, { useEffect, useState } from 'react';
import API from '../../services/api';
import { toast } from 'react-toastify';
import { ReactComponent as Edit } from '../../assets/editProfile.svg';
import { ReactComponent as DisEdit } from '../../assets/diseditPro.svg';
import { TextField } from '@material-ui/core';
import Constants from '../../services/constants';
import Validator from '../../services/validator';
import { ReactComponent as Success } from '../../assets/success.svg';
import Helper from '../../services/helper';
import { ErrorToast, SuccessToast } from '../../pure-components/CustomToast';
import { BouncingLoader } from '../../pure-components/Loader';
import Channels from './channels';
import CookieManager from '../../services/CookieManager';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SaveIcon from "@material-ui/icons/SaveOutlined";
import UpdateIcon from '@mui/icons-material/EditNote';
import EditIcon from '@mui/icons-material/Edit';

export default function Profile(props) {
  const [editProfile, setEditProfile] = useState(false);
  const [user, setUser] = useState({});
  const [helperText, setHelperText] = useState({})
  const [loading, SetLoading] = useState(true);
  const [editChannel, setEditChannel] = useState(false);

  let validator = new Validator();
  let userType = { ...JSON.parse(process.env.REACT_APP_USER_TYPE) };

  const defaultChannels = {
    "Youtube" : [],
    "Facebook" : [],
    "Instagram" : [],
    "Snapchat" : [],
    "X" : [],
    "Website" : [],
    "RSS" : []
  }
  const [channels, setChannels] = useState(defaultChannels);

  useEffect(() => {
    (async () => {
      await API.getUser().then(res => {
        if (res.success) {
          let tempUserData = res.data;
          setUser(res.data);
          if(res.data.channels)
            setChannels({...res.data.channels});
          else{
            setChannels(defaultChannels);
            setEditChannel(true);
          }
          //if userType is CORPORATE, load company Profile data from admin;
          if(res.data?.userType === "CORPORATE"){
            API.getAdminByEmail(res.data.admin).then(res => {
              if (res.success) {
                tempUserData["companyAddress"] = res.data.companyAddress;
                tempUserData.city = res.data.city;
                tempUserData.postalCode = res.data.postalCode;
                tempUserData.state = res.data.state;
                tempUserData.country = res.data.country;
                tempUserData.companyName = res.data.companyName;
                tempUserData.taxNumber = res.data.taxNumber;
                if(res.data.channels)
                  setChannels(res.data.channels);
                else
                  setChannels(defaultChannels);

                setUser(tempUserData);
                SetLoading(false);
              }else{
                toast(({ closeToast }) => <ErrorToast message={res?.message + res?.mssg} />);
              }

            })
          }else{
            SetLoading(false);
          }
        }else{
          toast(({ closeToast }) => <ErrorToast message={res?.message + res?.mssg} />);
        }
      })
    })();

  }, []);
  useEffect(() => {
  },[channels])

  const handleInputChange = (e, key) => {
    let value = key === 'tos' ? e : e.target.value;
    if (key === 'first_name') {
      let res = validator.setValue(value).isNotEmpty();
      let temp = { ...helperText };
      temp[key] = res.mssg;
      setHelperText(temp);
    }
    if (key === 'email') {
      let res = validator.setValue(value).isNotEmpty().isEmail();
      let temp = { ...helperText };
      temp[key] = res.mssg;
      setHelperText(temp);
    }
    if (key === 'oldPassword') {
      // console.log(user.password,"   ",user.oldPassword)
      if (value !== Helper.decode(user.password)) {
        let temp = { ...helperText };
        temp[key] = "Current password doesn't match";
        setHelperText(temp);
      } else {
        let temp = { ...helperText };
        temp[key] = "";
        setHelperText(temp);
      }
    }
    if (key === 'newPassword') {
      let res = validator.setValue(value,"New password").isNotEmpty().isString().checkPasswordStrength();
      let temp = { ...helperText };
      temp[key] = res.mssg;
      setHelperText(temp);
    }

    if (key === 'confirmPassword') {
      if (user.newPassword !== value) {
        let temp = { ...helperText };
        temp[key] = "Password doesn't match";
        setHelperText(temp);
      } else {
        let temp = { ...helperText };
        temp[key] = "";
        setHelperText(temp);
      }
    }
    if (key === 'companyName') {
      let res = validator.setValue(value).isString().doesNotContainSpecialChars();
      let temp = { ...helperText };
      temp[key] = res.mssg;
      setHelperText(temp);
    }
    if (key === 'taxNumber') {
      let res = validator.setValue(value).isString().isGSTIN();
      let temp = { ...helperText };
      temp[key] = res.mssg;
      setHelperText(temp);
    }

    let tempUser = { ...user };
    tempUser[key] = value;
    setUser(tempUser);
  };
  const changePassword = () => {
    if (user.oldPassword !== Helper.decode(user.password)) {
      let temp = {};
      temp["oldPassword"] = "Current password doesn't match";
      setHelperText(temp);
      return;

    }
    if (user.newPassword !== user.confirmPassword) {
      let temp = {}
      temp['confirmPassword'] = "Password doesn't match";
      setHelperText(temp);
      return;
    }
    API.updateUser({ password: Helper.encode(user.newPassword) }).then(data => {
      //   setTimeout(() => {
      // toast(({ closeToast }) => <div class="flex  m-1"><Success className="p-3 mr-2 border-r border-gray-500" />
      //   <div className="self-center">
      //     <h1 className='text-base text-black ' > Success. Great job!</h1>
      //     <h2 className='text-xs self-center text-gray-700 '> Password change successfully </h2>
      //   </div> </div>);
      toast(({ closeToast }) => <SuccessToast message="Password changed successfully" />);
      setTimeout(() => {
        Helper.signOut()
      }, 700);

    }).catch(err => {
      console.log("Error while changing password : ", err);
      toast(({ closeToast }) => <ErrorToast message={err?.msg || "Error while changing password"} />);
    })
  }
  const updateProfile = async() => {
    let counter = 0;
    let temp = { ...helperText };
    let resFirstName = new Validator(user.first_name).isNotEmpty().isString();
    temp['first_name'] = resFirstName.mssg;
    resFirstName.status === false && counter++;
    let resEmail = new Validator(user.email).isNotEmpty().isString().isEmail();
    temp['email'] = resEmail.mssg;
    resEmail.status === false && counter++;
    // COMPANY NAME IS NOT COMPULSORY FOR SOLO USER
    if (user.userType !== userType.FREE && user.userType !== userType.SOLO) {
      let resCompanyName = new Validator(user.companyName, "").isNotEmpty().doesNotContainSpecialChars();
      temp['companyName'] = resCompanyName.mssg;
      resCompanyName.status === false && counter++;
      let resTaxNumber = new Validator(user.taxNumber, "GST No.").isNotEmpty().isGSTIN();
      temp['taxNumber'] = resTaxNumber.mssg;
      resTaxNumber.status === false && counter++;
    }
    setHelperText(temp);

    if (counter === 0) {
      let userData = {};
      if(user.userType!== "CORPORATE"){
        userData = { ...user };
      }else{
        userData["first_name"] = user.first_name;
      }
      if(userData?.password?.length)
        delete userData.password;
      if(user.userType ===Constants.USER_TYPE.CORPORATE){
        delete userData["channels"];
      }else{
        userData["channels"] = channels;
      }
        
      await API.updateUser({ ...userData }).then(resp => {
        // toast(({ closeToast }) => <div className="flex  m-1"><Success className="p-3 mr-2 border-r border-gray-500" />
        //   <div className="self-center">
        //     <h1 className='text-base text-black ' > Success. Great job!</h1>
        //     <h2 className='text-xs self-center text-gray-700 '> User update successfully </h2>
        //   </div> </div>);
        toast(({ closeToast }) => <SuccessToast message="Profile updated successfully" />);

        setEditProfile(false);
        setEditChannel(false);
        const {
          first_name,
          last_name,
          email,
          _id,
          userType,
          productDesc,
          admin,
          totalLicenseCount,
          companyName,
          taxNumber,
          isSuspended,
          renewalDate,
          stripeCustomerId,
          subscriptionStatus,
          channels
        } = resp.data;
        const profileData = JSON.parse(CookieManager.getCookie("user-data") || "{}"); 
       
        const updatedProfile = {...profileData,
          first_name,
          last_name,
          email,
          _id,
          userType,
          productDesc,
          admin,
          totalLicenseCount,
          companyName,
          taxNumber,
          isSuspended,
          renewalDate,
          stripeCustomerId,
          subscriptionStatus
        }
        if(user.userType !==Constants.USER_TYPE.CORPORATE)
          updatedProfile.channels = channels

        CookieManager.setCookie("user-data", JSON.stringify(updatedProfile));
      }).catch(err => {
        console.log("Error while updating profile data : ", err);
        toast(({ closeToast }) => <ErrorToast message={err?.msg || "Error while updating profile data"} />);
      })
    }
  }

  
  return (
    <div className="w-full">
      <div className='w-full flex justify-center'>
        <span style={{ fontSize: "140px", marginTop: "-70px", color: "black"}}><AccountCircleIcon  fontSize="inherit"/></span>
      </div>
      <div className='w-full flex justify-start'>
        <span className='w-full profile-header flex justify-center'>Personal Information</span>
      </div>
      {loading ?
              <div className='w-full'>
                <BouncingLoader />
              </div>:
            <>
        {!editProfile &&
          <div className="w-full my-4 ">
            <div className='w-full flex py-4 border-b-2 border-black'>
              <div className='w-1/3 lic-title'> Full Name</div>
              <div className='w-2/3 lic-text'> {user.first_name}</div>
            </div>
            <div className='w-full flex py-4 border-b-2 border-black'>
              <div className='w-1/3 lic-title'> Email</div>
              <div className='w-2/3 lic-text'> {user.email}</div>
            </div>
            <div className='w-full flex py-4 border-b-2 border-black'>
              <div className='w-1/3 lic-title'> Address</div>
              <div className='w-2/3 lic-text'> {user.companyAddress}</div>
            </div>
            <div className='w-full flex py-4 border-b-2 border-black'>
              <div className='w-1/3 lic-title'> City</div>
              <div className='w-2/3 lic-text'> {user.city}</div>
            </div>
            <div className='w-full flex py-4 border-b-2 border-black'>
              <div className='w-1/3 lic-title'> Postal Code</div>
              <div className='w-2/3 lic-text'> {user.postalCode}</div>
            </div>
            <div className='w-full flex py-4 border-b-2 border-black'>
              <div className='w-1/3 lic-title'> State</div>
              <div className='w-2/3 lic-text'> {user.state}</div>
            </div>
            <div className='w-full flex py-4 border-b-2 border-black'>
              <div className='w-1/3 lic-title'> Country</div>
              <div className='w-2/3 lic-text'> {user.country}</div>
            </div>
            <div className='w-full flex py-4 border-b-2 border-black'>
              <div className='w-1/3 lic-title'> Company Name</div>
              <div className='w-2/3 lic-text'> {user.companyName}</div>
            </div>
            <div className='w-full flex py-4 border-b-2 border-black'>
              <div className='w-1/3 lic-title'> GST No.</div>
              <div className='w-2/3 lic-text'>{user.taxNumber}</div>
            </div>
            <div className='w-full lg:flex py-4 border-b-2 border-black'>
              <div className='w-1/3 lic-title'> Channels</div>
              <div className='w-2/3 lic-text'>
                {channels ? Object.keys(channels)?.map((channel)=><>
                  {
                  channels[channel]?.map(elem => <>
                  {elem?.length > 0 && 
                  <div className='w-full flex pb-1'>
                    <div>{Helper.getChannelIcon(channel)}</div>
                    <div className='px-2 w-full flex-wrap'>{elem}</div>
                  </div>}
                  </>)
                  }
                </>) : "No Channels Found!!!"}
              </div>
            </div>
            <div className='w-full flex py-4 border-b-2 border-black'>
              <div className='w-1/3 lic-title'> Password</div>
              <div className='w-2/3 lic-text'> ******** </div>
            </div>

            <div className='w-full flex justify-center items-center my-2'>
              <button className={`py-1 px-3 text-center cursor-pointer border-0`}
                style={{ fontSize: "14px", background: "rgb(var(--pink))", color: "white"}}
                onClick={() => setEditProfile(true)}
              >           
                <EditIcon className='mr-1 mb-1' />
                Edit
              </button>
            </div>
          </div>
        }
      </>
      }
      {
        editProfile &&
        <div className="w-full my-4">
          <div className='w-full flex py-4'>
            <div className='w-1/3 lic-title'> Full Name</div>
            <TextField 
              onChange={(e) => handleInputChange(e, 'first_name')}
              error={helperText.first_name !== undefined && helperText.first_name !== '' ? true : false}
              type="text"
              name="first_name"
              placeholder='Full Name'
              className="w-2/3 lic-text"
              value={user.first_name}
              helperText={helperText.first_name}
              style={{borderBottom: "solid 2px black"}}
            />
          </div>
          <div className='w-full flex py-4'>
            <div className='w-1/3 lic-title'> Email</div>
            <TextField 
              type="email"
              name="email"
              placeholder='Email'
              className="w-2/3 lic-text"
              value={user.email}
              disabled = {true}
              style={{borderBottom: "solid 2px black"}}
            />
          </div>
          <div className='w-full flex py-4'>
            <div className='w-1/3 lic-title'> Address Line</div>
            <TextField 
              onChange={(e) => handleInputChange(e, 'companyAddress')}
              name="companyAddress"
              type="text"
              placeholder='Address'
              className="w-2/3 lic-text"
              value={user.companyAddress}
              disabled = {user.userType === "CORPORATE"}
              style={{borderBottom: "solid 2px black"}}
            />
          </div>
          <div className='w-full flex py-4'>
            <div className='w-1/3 lic-title'> City</div>
            <TextField 
              onChange={(e) => handleInputChange(e, 'city')}
              type="text"
              name="city"
              placeholder='City'
              className="w-2/3 lic-text"
              value={user.city}
              disabled = {user.userType === "CORPORATE"}
              style={{borderBottom: "solid 2px black"}}
            />
          </div>
          <div className='w-full flex py-4'>
            <div className='w-1/3 lic-title'> Postal Code</div>
            <TextField 
              onChange={(e) => handleInputChange(e, 'postalCode')}
              type="text"
              name="postalCode"
              placeholder='Postal Code'
              className="w-2/3 lic-text"
              value={user.postalCode}
              disabled = {user.userType === "CORPORATE"}
              style={{borderBottom: "solid 2px black"}}
            />
          </div>
          <div className='w-full flex py-4'>
            <div className='w-1/3 lic-title'>State</div>
            <TextField 
              onChange={(e) => handleInputChange(e, 'state')}
              type="text"
              placeholder='State'
              className="w-2/3 lic-text"
              value={user.state}
              name="state"
              disabled = {user.userType === "CORPORATE"}
              style={{borderBottom: "solid 2px black"}}
            />
          </div>
          <div className='w-full flex py-4'>
            <div className='w-1/3 lic-title'>Country</div>
            <TextField 
              onChange={(e) => handleInputChange(e, 'country')}
              type="text"
              placeholder='Country'
              className="w-2/3 lic-text"
              value={user.country === "IN" || !user.country ? "India" : user.country}
              name="country"
              disabled
              style={{borderBottom: "solid 2px black"}}
            />
          </div>
          <div className='w-full flex py-4'>
            <div className='w-1/3 lic-title'> Company Name</div>
            <TextField 
              onChange={(e) => handleInputChange(e, 'companyName')}
              error={helperText.companyName !== undefined && helperText.companyName !== '' ? true : false}
              type="text"
              placeholder='Company Name'
              className="w-2/3 lic-text"
              value={user.companyName}
              name="companyName"
              helperText={helperText.companyName}
              disabled = {user.userType === "CORPORATE"}
              style={{borderBottom: "solid 2px black"}}
            />
          </div>
          <div className='w-full flex py-4'>
            <div className='w-1/3 lic-title'> GST No.</div>
            <TextField 
              onChange={(e) => handleInputChange(e, 'taxNumber')}
              error={helperText.taxNumber !== undefined && helperText.taxNumber !== '' ? true : false}
              type="text"
              placeholder='GST No.'
              className="w-2/3 lic-text"
              value={user.taxNumber}
              name="taxNumber"
              helperText={helperText.taxNumber}
              disabled = {user.userType === "CORPORATE"}
              style={{borderBottom: "solid 2px black"}}
            />
          </div>
          {user.userType !==Constants.USER_TYPE.CORPORATE &&
          <div className='my-3'>
            <h1 className='w-full flex lic-title' >Channels</h1>
            <Channels userType={user.userType}  channels={{...channels}} setChannels={setChannels} editChannel={editChannel}/>
          </div>
          }
          <div className='w-full flex justify-center items-center my-2'>
            <button className={`py-1 px-3 text-center cursor-pointer border-0`}
              style={{ fontSize: "14px", background: "rgb(var(--pink))", color: "white"}}
              onClick={updateProfile}
            >           
              <SaveIcon className='mr-1 mb-1' />
              Save
            </button>

            <button className={`ml-2 py-2 px-3 text-center cursor-pointer border-0`}
                style={{ fontSize: "14px", background: "black", color: "white"}}
                onClick={() => setEditProfile(false)}
              >           
                Cancel
              </button>
          </div>
          {/* Removing change password flow from profile page */}
          {/* <h1 className='w-full sm:w-1/3 pt-10 pb-4 text-base font-bold text-black' > Change Password</h1>
          <div className='sm:flex my-3'>
            <div className='w-full sm:w-1/3 text-base self-center'> Current Password</div>
            <TextField variant="outlined"
              // onChange={(e) => { handleSearch(e.target.value) }}
              // onChange={handleSearch}
              error={helperText.oldPassword !== undefined && helperText.oldPassword !== '' ? true : false}
              type="password"
              placeholder='Current Password'
              className="w-full sm:w-2/3  p-4 outline-none border border-textGray-300 text-textGray-500"
              value={user.oldPassword || ''}
              helperText={helperText.oldPassword}
              onChange={(e) => handleInputChange(e, 'oldPassword')}

            />
          </div>
          <div className='sm:flex my-3'>
            <div className='w-full sm:w-1/3 text-base self-center'> New Password</div>
            <TextField variant="outlined"
              error={helperText.newPassword !== undefined && helperText.newPassword !== '' ? true : false}
              type="password"
              placeholder='New Password'
              className="w-full sm:w-2/3  p-4 outline-none border border-textGray-300 text-textGray-500"
              helperText={helperText.newPassword}
              onChange={(e) => handleInputChange(e, 'newPassword')}

            />
          </div>

          <div className='sm:flex my-3'>
            <div className='w-full sm:w-1/3 text-base self-center'>  Confirm Password</div>
            <TextField variant="outlined"
              error={helperText.confirmPassword !== undefined && helperText.confirmPassword !== '' ? true : false}
              type="password"
              placeholder=' Confirm Password'
              className="w-full sm:w-2/3  p-3 outline-none border border-textGray-300 text-textGray-500"
              helperText={helperText.confirmPassword}
              onChange={(e) => handleInputChange(e, 'confirmPassword')}

            />

          </div>
          <div className='flex my-6 w-4/6'>
            <div className='w-3/6 text-base self-center'></div>
            <div className={`greenbutton cursor-pointer`}
              onClick={changePassword}
            > Save
            </div>
          </div> */}
        </div>
      }
    </div>
  )
}
